import styled from 'styled-components';

const snackBarBackground = ({ $type }) => {
  if ($type === 'error') return '#c62828';
  if ($type === 'success') return '#2e7d32';
  return 'rgba(0, 0, 0, 0.6)';
};

export const SnackBarContainer = styled.div`
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: ${props => (props.show ? '40px' : '-90px')};
  transition: margin 200ms ease-in-out;
  padding: 15px 30px;
  color: white;
  background-color: ${snackBarBackground};
  border-radius: 10px;
  z-index: 10000;
  max-width: calc(100vw - 48px);
  text-align: center;
  white-space: pre-wrap;
`;
